import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";
import { pk, iv } from "@/config/index";
// rsa加密
export function encryptedRsa(publicKey) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    return encrypt.encrypt("angE5imgcE5EhAkM");
}
// aes解密
export function decryptedAes({ data, url }) {
    let reaKey = "";
    let bytes = null;
    if (sessionStorage.getItem("reaKey")) {
        reaKey = sessionStorage.getItem("reaKey");
    }
    let newApiArr = ['/integration/info', '/integration/basic_info', '/integration/business_info', '/integration/cert_info', '/integration/other_info', '/integration/info_check'];
    if (["/transfer/get_data", "/manage/get_data", ...newApiArr].includes(url)) {
        bytes = CryptoJS.AES.decrypt(data.data, CryptoJS.enc.Utf8.parse(pk), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CTR,
            padding: CryptoJS.pad.NoPadding,
        });
    }
    else {
        bytes = CryptoJS.AES.decrypt(data.data, CryptoJS.enc.Utf8.parse(reaKey), {
            iv: CryptoJS.enc.Utf8.parse("xkDwWnZYH4t2ATws"),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
    }
    data.data = bytes.toString(CryptoJS.enc.Utf8)
        ? JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        : "";
    return data;
}
